export function strLength(str) {
  if (str === null || str === undefined) {
    return 0;
  }
  str = '' + str;

  return Math.ceil(str.replace(/[\u00FF-\uFFFF]/g, '**').length / 2);
}

export function interceptUnknownEmoji(input) {
  var reg = /[^\u3400-\u9fffa-z0-9]/gi;
  const str = input.replace(reg, function(matchChar) {
    if (matchChar.codePointAt(0) === 65533) {
      return '❓';
    }
    return matchChar;
  });

  return str;
}
